import { OverlayTrigger, Tooltip } from "react-bootstrap";

const MultiLineText = ({ text, maxWidth = "100%", span = false, dangerouslySetInnerHTML = false }) => {
    return (
        <OverlayTrigger
            placement="top"
            overlay={
                <Tooltip>
                    {text}
                </Tooltip>
            }
        >
            {
                dangerouslySetInnerHTML ? <p className="multiline-text mb-0 text-truncate" style={{ maxWidth: maxWidth }} dangerouslySetInnerHTML={{ __html: text }}></p> :
                    <p className="multiline-text mb-0 text-truncate" style={{ maxWidth: maxWidth }}>
                        {span ? <span>{text}</span> : text}
                    </p>
            }
        </OverlayTrigger>
    );
};

export default MultiLineText;
